import { LabCaseRunPrintOptionsModel } from '@app/api2/api';
import SemanticField from '@app/components/SemanticField';
import * as React from 'react';
import { Checkbox, Grid, GridColumn, Table, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import { typedName, typedName2 } from '@common/Utils';

export function LabPrintingOptionsView(props: { readOnly?: boolean; options: LabCaseRunPrintOptionsModel }) {
    const t = window.translation;

    return (<Grid columns={2}>
        {[{
            label: t.caseRunView.information,
            items: [{
                label: t.caseRunView.caseRunDetails2,
                name: typedName2(props.options, 'caseRunDetails')
            }, {
                label: t.caseRunView.notes,
                name: typedName2(props.options, 'caseRunNotes')
            }, {
                label: t.caseRunView.aicRuns,
                name: typedName2(props.options, 'aicRuns')
            }]
        }, {
            label: t.common.results,
            items: [{
                label: t.caseRunView.mlSystemRatio,
                name: typedName2(props.options, 'resultsMlSystems')
            }, {
                label: t.caseRunView.weightOfEvidence,
                name: typedName2(props.options, 'resultsWeightOfEvidence')
            }, {
                label: t.caseRunView.epgOverlay,
                name: typedName2(props.options, 'resultsEpgOverlay')
            }, {
                label: t.caseRunView.sensitivity,
                name: typedName2(props.options, 'resultsSensitivityGraph')
            }, {
                label: t.caseRunView.bayesianNumerical,
                name: typedName2(props.options, 'resultsBayesianNumericalParameters')
            }, {
                label: t.caseRunView.mcmcParameters,
                name: typedName2(props.options, 'resultsMcmcParameters')
            }, {
                label: t.runType.dnamatch,
                name: typedName2(props.options, 'sentryResults')
            }]
        }, {
            label: t.caseRunView.hp,
            items: [{
                label: t.caseRunView.parameterEstimates,
                name: typedName2(props.options, 'hpParameterEstimates')
            }, {
                label: t.caseRunView.modelValidation,
                name: typedName2(props.options, 'hpModelValidation')
            }, {
                label: t.caseRunView.mcmcParameters,
                name: typedName2(props.options, 'hpMcmcParameters')
            }, {
                label: t.caseRunView.hpFittedModel,
                name: typedName2(props.options, 'hpFittedModel')
            }, {
                label: t.caseRunView.topMarginal,
                name: typedName2(props.options, 'hpDeconvTopMarginal')
            }, {
                label: t.caseRunView.allJoint,
                name: typedName2(props.options, 'hpDeconvAllJoint')
            }, {
                label: t.caseRunView.allMarginalGenotypes,
                name: typedName2(props.options, 'hpDeconvAllMarginalGeno')
            }, {
                label: t.caseRunView.allMarginalAlleles,
                name: typedName2(props.options, 'hpDeconvAllMarginalAlleles')
            }]
        }, {
            label: t.caseRunView.hd,
            items: [{
                label: t.caseRunView.parameterEstimates,
                name: typedName2(props.options, 'hdParameterEstimates')
            }, {
                label: t.caseRunView.modelValidation,
                name: typedName2(props.options, 'hdModelValidation')
            }, {
                label: t.caseRunView.mcmcParameters,
                name: typedName2(props.options, 'hdMcmcParameters')
            }, {
                label: t.caseRunView.hdFittedModel,
                name: typedName2(props.options, 'hdFittedModel')
            }, {
                label: t.caseRunView.topMarginal,
                name: typedName2(props.options, 'hdDeconvTopMarginal')
            }, {
                label: t.caseRunView.allJoint,
                name: typedName2(props.options, 'hdDeconvAllJoint')
            }, {
                label: t.caseRunView.allMarginalGenotypes,
                name: typedName2(props.options, 'hdDeconvAllMarginalGeno')
            }, {
                label: t.caseRunView.allMarginalAlleles,
                name: typedName2(props.options, 'hdDeconvAllMarginalAlleles')
            }]
        }].map((m, idx) => <GridColumn key={`mm${m.label}${m.label}${idx}`}>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <span dangerouslySetInnerHTML={{
                                __html: m.label
                            }}></span>
                            {/* <BPCheckbox onChange={() => {
                                
                            }}></BPCheckbox> */}
                        </TableCell>
                    </TableRow>

                    {m.items && m.items.map(mi => <TableRow key={`mm${m.label}${mi.label}${idx}`}>
                        {mi.name && <>
                            <TableCell width={'1'}><SemanticField name={mi.name} readOnly={props.readOnly} component={Checkbox}></SemanticField></TableCell>
                            <TableCell><span dangerouslySetInnerHTML={{
                                __html: mi.label
                            }}></span></TableCell>
                        </>}
                    </TableRow>)}
                </TableBody>
            </Table>
        </GridColumn>)}
    </Grid>);
}
